import { useState } from "react"
import { getUrlParameter } from "../utils/general"

const PRODMAP = {
  onemonthsub: 0,
  threemonthsubrefill: 1,
  sixmonthsubrefill: 2,
  singlepurchase: 3
}

const PRODSKUMAP = {
  wom: 'Women',
  veg: 'Vegan',
  bal: 'Balance',
  pos: 'Postpartum',
  men: 'Men'
}

function useQueryParam () {
  
  // get selprod in URL and make sure it is in range.
  
  /**
   * selprod tests
   * https://localhost:8000/nutrafol-core-for-women/?selprod=onemonthsub
   * https://localhost:8000/nutrafol-core-for-women/?selprod=threemonthsubrefill
   * https://localhost:8000/nutrafol-core-for-women/?selprod=sixmonthsubrefill
   * https://localhost:8000/nutrafol-core-for-women/?selprod=singlepurchase
   */
  
  // get SKU in URL and make sure it is in range.
  
  /**
   * sku tests
   * https://localhost:8000/nutrafol-core-for-women/?sku=WOM1-S01
   * https://localhost:8000/nutrafol-core-for-women/?sku=WOM3-S01
   * https://localhost:8000/nutrafol-core-for-women/?sku=WOM6-S01
   * https://localhost:8000/nutrafol-core-for-women/?sku=WOM1-N01
   */
  
  const selprod = PRODMAP[getUrlParameter("selprod")] || 0
  const selsku = getUrlParameter("sku") ? getUrlParameter("sku").toLowerCase() : null
  const hasQueryParam = selprod || selsku
  const [needQueryParam, setNeedQueryParam] = useState(hasQueryParam)
  
  let getProductBySku = ()=> {
    if (selsku) {
      const selskucode = selsku.slice(0, 3)
      return PRODSKUMAP[selskucode] || null
    }
    return null
  }
  
  /**
   **
   * triggerSelection based on sku OR selprod in URL
   * @param options
   * @param activeOption
   * @param setActiveOption
   */
  const triggerSelection = (options, activeOption, setActiveOption)=>{
    const skus = options.map(el=>el?.sku?.toLowerCase())
    if(needQueryParam && skus){
      //console.log('triggerSelection' , skus)
      let skuidx = selsku ? skus.indexOf(selsku) : -1
      // if valid sku passed - use it
      if(skuidx > -1){
        if((activeOption !== skuidx) && options[skuidx]) {
          setActiveOption(skuidx)
        }
      }
      // if NO  valid sku passed AND valid selprod passed - use it
      else {
        if((activeOption !== selprod) && options[selprod]) {
          setActiveOption(selprod)
        }
      }
      setNeedQueryParam(false)
    }
  }
  
  return [triggerSelection, getProductBySku, selsku, selprod, needQueryParam, setNeedQueryParam]
}

export default useQueryParam